import React from "react"

import { RichText, Wrapper } from "components"

const IntroSection = ({ data }) => {
  return (
    <>
      {data.bodyContent && (
        <Wrapper id="howDoYouDT-intro">
          <RichText
            content={{
              html: data.bodyContent,
            }}
            size={600}
            maxWidth={768}
          />
        </Wrapper>
      )}
    </>
  )
}

export default IntroSection
